window.openNav = () => {
  document.querySelector('.companies__sidebar').classList.add('open');
};
window.closeNav = () => {
  document.querySelector('.companies__sidebar').classList.remove('open');
};
